import styled from '@emotion/styled'
import { Box, Stack } from '@mui/material'
import theme from 'theme'

export const MonthPickerWrapper = styled(Box)<{ isopen: string }>`
  display: none;
  align-items: center;
  width: 456px;
  margin-top: -${theme.spacing.xSmall}px;
  background-color: ${theme.colors.borderMedium};

  html[data-theme='light'] & {
    background-color: ${theme.colors.surfaceContainerBackground};
  }

  ${({ isopen }) =>
    isopen === 'true' &&
    `
      display: flex;
    `};

  .month-calendar-container {
    .month-picker-monthly-title {
      color: ${theme.colors.menuItemText};
      text-align: center;
      font-family: ${theme.typography.fontFamily.primary};
      font-size: ${theme.typography.fontSize.xLarge};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.bold};
      line-height: ${theme.typography.fontSize.xxxLarge};
      letter-spacing: 0.1px;
      border-bottom: 1px solid ${theme.colors.dropdownBorder};
      padding: ${theme.spacing.small}px ${theme.spacing.xxxLg}px ${theme.spacing.xSmall}px ${theme.spacing.xxxLg}px;
    }

    .MuiMonthCalendar-root {
      width: 228px;

      .MuiPickersMonth-root {
        .MuiPickersMonth-monthButton {
          width: 40px;
          height: 40px;
          color: ${theme.colors.devicesSecondaryText};
          text-align: center;
          font-family: ${theme.typography.fontFamily.primary};
          font-size: ${theme.typography.fontSize.large};
          font-style: normal;
          font-weight: ${theme.typography.fontWeight.normal};
          line-height: ${theme.typography.fontSize.header};
          letter-spacing: 0.25px;

          &.Mui-selected {
            border-radius: ${theme.attributes.borderRadius.circle};
            color: ${theme.baseColors.primary[20]};
            background: ${theme.colors.cta};
          }

          &.Mui-disabled {
            color: ${theme.baseColors.greyscale[80]};
          }
        }
      }

      .MuiPickersCalendarHeader-root {
        div {
          display: flex;
          justify-content: center;
          width: 100%;
        }

        .MuiPickersArrowSwitcher-root {
          display: none;
        }
      }
    }
  }
`

export const MonthPickerActions = styled(Stack)`
  padding: 0 ${theme.spacing.xSmall}px ${theme.spacing.small}px ${theme.spacing.medium}px;

  button {
    padding: ${theme.spacing.xsm}px ${theme.spacing.xSmall}px;
    color: ${theme.colors.menuItemText};

    &:not(:disabled):last-child {
      color: ${theme.colors.cta};
    }

    &:disabled {
      color: ${theme.colors.mutedMauve};
    }

    &:hover {
      background-color: ${theme.colors.dropdownBorder};
    }
  }
`
